import script from "./saleSendDetailBack.vue?vue&type=script&setup=true&lang=js"
export * from "./saleSendDetailBack.vue?vue&type=script&setup=true&lang=js"

import "./saleSendDetailBack.vue?vue&type=style&index=0&id=ab150a14&lang=less"

const __exports__ = script;

export default __exports__